import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-subpage-encuentros-empoderarse-para-volver',
  templateUrl: './subpage-encuentros-empoderarse-para-volver.component.html',
  styleUrls: ['./subpage-encuentros-empoderarse-para-volver.component.scss']
})
export class SubpageEncuentrosEmpoderarseParaVolverComponent implements OnInit {

  constructor() { 
    window.scroll(0,0);
  }

  ngOnInit() {
  }

}
